// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.E9vTeV {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding-top: var(--spacing-1); /* 8px - Padding superior do item */
  padding-right: var(--spacing-1-5); /* 12px - Padding direito do item */
  padding-bottom: var(--spacing-1); /* 8px - Padding inferior do item */
  padding-left: var(--spacing-1-5); /* 12px - Padding esquerdo do item */
  background-color: var(--surface-neutral-pale);
  border: none;
  border-radius: var(--radius-s); /* 4px - Border radius padrão */
}

.znrMln {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular); /* 400 - Peso regular */
  font-size: var(--font-size-md); /* 14px - Tamanho médio */
  line-height: 1.424; /* Line height específico do Figma - mantido */
  color: var(--profile-menu-user-name-color);
  margin: 0;
  flex: 1;
  text-align: left;
}

.qZzRlk {
  width: 16px; /* Tamanho específico do ícone do Figma - mantido */
  height: 16px; /* Tamanho específico do ícone do Figma - mantido */
}

.t0EOFu {
  font-size: var(--font-size-sm); /* 12px */
  background: var(--inline-error-background); /* #FEE7E7 */
  border: 1px solid var(--status-error); /* #DC0A0A */
  padding: 0 var(--spacing-0-5);
  border-radius: var(--radius-pill);
  margin: 0 0 0 var(--spacing-1-5);
  font-weight: var(--font-weight-semibold);
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/ProfileMenuItem/ProfileMenuItem.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,6BAA6B,EAAE,mCAAmC;EAClE,iCAAiC,EAAE,mCAAmC;EACtE,gCAAgC,EAAE,mCAAmC;EACrE,gCAAgC,EAAE,oCAAoC;EACtE,6CAA6C;EAC7C,YAAY;EACZ,8BAA8B,EAAE,+BAA+B;AACjE;;AAEA;EACE,oCAAoC;EACpC,uCAAuC,EAAE,uBAAuB;EAChE,8BAA8B,EAAE,yBAAyB;EACzD,kBAAkB,EAAE,8CAA8C;EAClE,0CAA0C;EAC1C,SAAS;EACT,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW,EAAE,mDAAmD;EAChE,YAAY,EAAE,mDAAmD;AACnE;;AAEA;EACE,8BAA8B,EAAE,SAAS;EACzC,0CAA0C,EAAE,YAAY;EACxD,qCAAqC,EAAE,YAAY;EACnD,6BAA6B;EAC7B,iCAAiC;EACjC,gCAAgC;EAChC,wCAAwC;AAC1C","sourcesContent":[".item {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n  padding-top: var(--spacing-1); /* 8px - Padding superior do item */\n  padding-right: var(--spacing-1-5); /* 12px - Padding direito do item */\n  padding-bottom: var(--spacing-1); /* 8px - Padding inferior do item */\n  padding-left: var(--spacing-1-5); /* 12px - Padding esquerdo do item */\n  background-color: var(--surface-neutral-pale);\n  border: none;\n  border-radius: var(--radius-s); /* 4px - Border radius padrão */\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular); /* 400 - Peso regular */\n  font-size: var(--font-size-md); /* 14px - Tamanho médio */\n  line-height: 1.424; /* Line height específico do Figma - mantido */\n  color: var(--profile-menu-user-name-color);\n  margin: 0;\n  flex: 1;\n  text-align: left;\n}\n\n.icon {\n  width: 16px; /* Tamanho específico do ícone do Figma - mantido */\n  height: 16px; /* Tamanho específico do ícone do Figma - mantido */\n}\n\n.info {\n  font-size: var(--font-size-sm); /* 12px */\n  background: var(--inline-error-background); /* #FEE7E7 */\n  border: 1px solid var(--status-error); /* #DC0A0A */\n  padding: 0 var(--spacing-0-5);\n  border-radius: var(--radius-pill);\n  margin: 0 0 0 var(--spacing-1-5);\n  font-weight: var(--font-weight-semibold);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `E9vTeV`,
	"title": `znrMln`,
	"icon": `qZzRlk`,
	"info": `t0EOFu`
};
module.exports = ___CSS_LOADER_EXPORT___;
